
import React,{useState, useRef} from 'react'
import { number } from 'yup/lib/locale'
import SendFileForPreview from './redux/FileSender'
import { useSelector, useDispatch } from "react-redux";
import {setOrders} from '../preview/redux/previewSlice'
import { current } from '@reduxjs/toolkit';  
import {Link} from "react-router-dom";
 


export default function FileSend(){
    const [selectedFile, setSelectedFile] = useState();
	const [isFilePicked, setIsFilePicked] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false)

    const currentRef = useRef(null);
    const uploadButtonRef = useRef(null);
    console.log(currentRef);

    const dispatch = useDispatch();
	const changeHandler = (event) => {
		setSelectedFile(event.target.files[0]);
		setIsFilePicked(true);
        console.log("Type =>",typeof(event.target.files[0]))
        setTimeout(() => {
            uploadButtonRef.current.click();
        }, 300);
	};

    const clicked = (event) => {
        event.target.value = ''
    }
   
    
	const handleSubmission = async () => {
        if(isFilePicked){
            if(selectedFile != null){
                setPreviewLoading(true);
                var response = await SendFileForPreview(selectedFile);
                console.log("Response döndü 21 => ", response);
                if(response?.data.Status == "SUCCESS"){
                        var OrderList = response.data.Detail;
                        console.log("OrderList =>>",OrderList);
                        setPreviewLoading(false);
                        dispatch(setOrders(null))
                        dispatch(setOrders(OrderList));
                }else{
                    setPreviewLoading(false);
                    console.log("Error",response?.Detail);
                }
            }
        }
	};
    const fileUploadAction = () => {
        currentRef.current.click()
    }

    return(
        <div className={`card card-xxl-stretch`}>
                {/* begin::Header */}
                <div className='card-header align-items-center border-0 mt-4' style={{display:'block'}}>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='fw-bolder mb-2 text-dark'>Sipariş Oluştur</span>
                    <span className='text-muted fw-bold fs-7'>Lütfen sipariş oluşturmak için excel dosyası(.xls, xlsx)</span>
                </h3>
                <div className='card-toolbar'>
                {/* end::Header */}
                {/* begin::Body */}
                
                <div className='card-body pt-5' style={{paddingLeft:0,marginBottom:15}}>
                    {/* <input type="file" name="file" onChange={changeHandler} /> */}
                    
                    <input type="file" hidden ref={currentRef} onChange={changeHandler} onClick={clicked} />
                    <button onClick={fileUploadAction}  className="btn btn-icon btn-info">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-symlink-fill" viewBox="0 0 16 16">
                            <path d="M13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2l.04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3zM2.19 3c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672a1 1 0 0 1 .707.293L7.586 3H2.19zm9.608 5.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z"/>
                        </svg>
                    </button>
                <div style={{display:'inline',marginLeft:7}}>
                    <button className="btn btn-success" onClick={handleSubmission} disabled={previewLoading} ref={uploadButtonRef}>
                        <svg stlye={{marginRight:3}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-upload" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                            <path fillRule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>
                        </svg>
                        {!previewLoading && <span className='indicator-label'>Yükle</span>}
                        {previewLoading && (
                            <span className='indicator-progress' style={{display: 'inline',paddingLeft:10}}>
                            Yükleniyor...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )} 
                    </button>
                    <Link to="/file/Ornek_Siparis_Dosyasi_.xlsx" target="_blank"  style={{marginLeft:5}} className="btn btn-warning" download >
                        Örnek Şablon
                    </Link>
                </div>
                </div>
                </div>
                {/* end: Card Body */}
            </div>
      </div>
    )
}